import {fileFormatTokens, semanticColors, tokens} from '../tokens/tokens';
import {BrandColors} from "../palettes/types";

export const buildLightPalette = (brandColors: BrandColors) => ({
    mode: 'light' as const,
    contrastThreshold: 4.5,

    primary: {
        main:         brandColors.primary.main,
        dark:         brandColors.primary.dark,
        light:        brandColors.primary.light,
        contrastText: brandColors.primary.contrastText,
    },

    secondary: {
        main:         brandColors.secondary.main,
        dark:         brandColors.secondary.dark,
        light:        brandColors.secondary.light,
        contrastText: brandColors.secondary.contrastText,
    },

    link: {
        main:         brandColors.link.main,
        dark:         brandColors.link.dark,
        light:        brandColors.link.light,
        contrastText: brandColors.link.contrastText,
    },

    text: {
        primary:     brandColors.text.primary,
        secondary:   brandColors.text.secondary,
        disabled:    brandColors.text.disabled,
        hint:        brandColors.text.hint,
        inverse:     brandColors.text.inverse,
        placeholder: brandColors.text.placeholder,
    },

    background: {
        default:   brandColors.background.default,
        paper:     brandColors.background.paper,
        subtle:    brandColors.background.subtle,
        overlay:   brandColors.background.overlay,
        dropzone:  brandColors.background.dropzone,
        element:   brandColors.background.element,
        input:     brandColors.background.input,
    },

    action: {
        hover:              brandColors.action.hover,
        hoveredBackground:  brandColors.action.hoveredBackground,
        selected:           brandColors.action.selected,
        selectedBackground: brandColors.action.selectedBackground,
        focus:              brandColors.action.focus,
        disabled:           brandColors.action.disabled,
        disabledBackground: brandColors.action.disabledBackground,
        delete:             brandColors.action.delete,
        dragDrop:           brandColors.action.dragDrop,
        hoveredDropzone:    brandColors.action.hoveredDropzone,
    },

    layout: {
        main:    brandColors.layout.main,
        sidebar: brandColors.layout.sidebar,
    },

    divider: tokens.colors.slate200,

    dividers: {
        light:   tokens.colors.gray200,
        subtle:  tokens.colors.gray300,
        default: tokens.colors.slate200,
        strong:  tokens.colors.gray500,
        focus:   tokens.colors.slate600,
    },

    message: {
        userText:        brandColors.message.userText,
        userBg:          brandColors.message.userBg,
        userTextBg:      brandColors.message.userTextBg,
        assistantText:   brandColors.message.assistantText,
        assistantBg:     brandColors.message.assistantBg,
        assistantTextBg: brandColors.message.assistantTextBg,
        thinking:        brandColors.message.thinking,
    },

    error: {
        light:        tokens.colors.red50,
        main:         tokens.colors.red500,
        dark:         tokens.colors.red700,
        contrastText: tokens.colors.white,
    },

    fileFormats: fileFormatTokens.light,

    semanticColors: semanticColors,
});